import { styled } from 'styled-components';

export const AnimatedIconHolder = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  pointer-events: none;
`;
